import { createRoot } from 'react-dom/client';

import RootApp from './RootApp';
import { registerServiceWorker } from './utils/registerServiceWorker';

// Register service worker for PWA support
if (import.meta.env.PROD || window.location.hostname === 'localhost') {
  registerServiceWorker({
    onSuccess: (registration) => {
      console.log('[SW] Service worker registered successfully');
    },
    onUpdate: (registration) => {
      console.log('[SW] New version available. Reload to update.');
      // Optionally show a toast/banner to user
    },
    onError: (error) => {
      console.error('[SW] Service worker registration failed:', error);
    },
  });
}

const root = createRoot(document.getElementById('root'));
root.render(<RootApp />);
